import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { get } from 'rf-lib';
import Menu from './Menu';

const Page = styled.div`
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${get('spacingLg')} ${get('spacingMd')};
`;

const Children = styled.div`
  width: 100%;
`;

const PageWrapper = ({ children }) => (
  <Page>
    <Menu />
    <Content>
      <Children>
        {children}
      </Children>
    </Content>
  </Page>
);

PageWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired
};

export default PageWrapper;
